import { ReactNode } from "react";
import { NavLinkProps } from "react-router-dom";

import { HeaderLink } from "./HeaderLink";

type Props = {
  showRedirectModal: (to: string) => void;
  to: string;
  icon: ({ ...props }: React.SVGProps<SVGSVGElement>) => JSX.Element;
  children: ReactNode;
  isActive?: NavLinkProps["isActive"];
};

const AppHeaderLinkItem = ({ showRedirectModal, to, icon, children, isActive }: Props) => {
  return (
    <div className="App-header-link-container">
      <HeaderLink to={to} showRedirectModal={showRedirectModal} isActive={isActive}>
        {icon && icon({ className: "App-header-link-container__icon" })}
        {children}
      </HeaderLink>
    </div>
  );
};

export default AppHeaderLinkItem;
